import { Components, Theme } from '@mui/material';

const MuiAccordionSummary: Components<Theme>['MuiAccordionSummary'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      padding: theme.spacing(theme.spacingSizes.lg, 0, 0, 0),
      minHeight: 0,
      '&.Mui-expanded': {
        minHeight: 0,
      },
    }),
    content: {
      margin: 0,
      '&.Mui-expanded': {
        margin: 0,
      },
    },
  },
};

export default MuiAccordionSummary;
